"use client";

// EquipmentBootstrap — invisible component mounted by the app layout
// that auto-fetches the selected character's equipment on every page.
//
// Without this, if a user hard-loaded /recommendations or /bis straight
// after sign-in (without hitting /dashboard first), the engine would
// run with empty equippedMyth, recommending bonus rolls for slots the
// user already had at Myth. Now equipment auto-loads regardless of
// which page is the entry point.

import { useEnsureEquipmentLoaded } from "@/lib/equipment";

export function EquipmentBootstrap() {
  useEnsureEquipmentLoaded();
  return null;
}
